module.exports = __webpack_public_path__ + "static/media/download-pc.bb2103fa.png";